// extracted by mini-css-extract-plugin
export default {"table":"PrecoAtacadoTable_table__iuZoj","padding-inline-xxs":"PrecoAtacadoTable_padding-inline-xxs__HGkum"};